module.exports = __webpack_public_path__ + "img/kv__hands2.663d54ed.svg";